"use client";

import type React from "react";
import { ArrowRight, MapPinned } from "lucide-react";
import { getReadableTextColor } from "@/features/landing-pages/_logic/color-utils";
import { useBuilderContext } from "../../_hooks/useBuilderContext";

interface ResortMapLinkProps {
  href: string;
  label: string;
}

/**
 * Small, palette-aware pill linking to the event's interactive resort map. Rendered once on the
 * public landing page (below the hero) — deliberately not a navbar item.
 *
 * @param props - Link target and label.
 * @returns The link band.
 */
export function ResortMapLink({ href, label }: ResortMapLinkProps): React.ReactElement {
  // Hooks
  const { primaryColor, backgroundColor } = useBuilderContext();

  // Derived values
  const accent = getReadableTextColor(primaryColor, backgroundColor);

  // Render
  return (
    <div className="flex justify-center px-4 py-4" style={{ backgroundColor }}>
      <a
        href={href}
        className="inline-flex touch-manipulation items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium shadow-sm transition-opacity hover:opacity-80"
        style={{ color: accent, borderColor: `${accent}55` }}
      >
        <MapPinned className="h-4 w-4" aria-hidden="true" />
        {label}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>
  );
}
